<div class="main-container-n-tester">
    <div class="close-btn-container" (click)="close()">
        <img src="../../assets/icons/close.svg" alt="Close Icon" class="close-icon">
    </div>
    <div class="n-tester-pin-close-container">
        <div class="header-container-new-n-tester-pin">
            <span><img src="../../assets/icons/Ntester_pin.png" alt="New Pin Icon" class="new-n-tester-pin-header-icon">
            </span>
            <h1 mat-dialog-title class="new-n-tester-pin-header">N-Tester</h1>
        </div>
    </div>

    <div class="n-tester-pin-info-container">

        <div class="n-tester-pin-container">
            <div class="n-tester-pin-headers">
                <p class="n-tester-pin-header-text">Date and Time:</p>
                <p class="n-tester-pin-header-text">Latitude:</p>
                <p class="n-tester-pin-header-text">Longitude:</p>
                <p class="n-tester-pin-header-text">Farm:</p>
                <p class="n-tester-pin-header-text">Field:</p>
                <p class="n-tester-pin-header-text" *ngIf="pinObj.variety">Variety:</p>
                <p class="n-tester-pin-header-text" *ngIf="pinObj.crop">Crop:</p>
                <p class="n-tester-pin-header-text" *ngIf="pinObj.cultivar">Cultivar:</p>
                <p class="n-tester-pin-header-text" *ngIf="pinObj.growthStage">Growth Stage:</p>
                <p class="n-tester-pin-header-text" *ngIf="pinObj.totalNitrogen">Total Nitrogen:</p>
                <p class="n-tester-pin-header-text" *ngIf="pinObj.medianValue">Median Value:</p>
                <p class="n-tester-pin-header-text" *ngIf="pinObj.averageValue">Average Value:</p>
                <p class="n-tester-pin-header-text" *ngIf="pinObj.yieldTarget">Yield Target:</p>
                <p class="n-tester-pin-header-text" *ngIf="pinObj.alreadyApplied">Already Applied:</p>
                <p class="n-tester-pin-header-text" *ngIf="pinObj.proteinTarget">Protein Target:</p>
                <p class="n-tester-pin-header-text" *ngIf="pinObj.nRecommendation">N Recommendation:</p>
            </div>

        </div>

        <div class="n-tester-pin-container">
            <ng-container>
                <p class="n-tester-pin-info-text">{{pinObj.date ? dayjs(pinObj.date).format(dateStringFormatting) : placeholder}}</p>
                <p class="n-tester-pin-info-text">{{pinObj.lat}}</p>
                <p class="n-tester-pin-info-text">{{pinObj.lng}}</p>
                <p class="n-tester-pin-info-text">{{pinObj.farm}}</p>
                <p class="n-tester-pin-info-text">{{pinObj.field}}</p>
                <p class="n-tester-pin-info-text" *ngIf="pinObj.variety">{{pinObj.variety}}</p>
                <p class="n-tester-pin-info-text" *ngIf="pinObj.crop">{{pinObj.crop}}</p>
                <p class="n-tester-pin-info-text" *ngIf="pinObj.cultivar">{{pinObj.cultivar}}</p>
                <p class="n-tester-pin-info-text" *ngIf="pinObj.growthStage">{{pinObj.growthStage}}</p>
                <p class="n-tester-pin-info-text" *ngIf="pinObj.totalNitrogen">{{pinObj.totalNitrogen}}</p>
                <p class="n-tester-pin-info-text" *ngIf="pinObj.medianValue">{{pinObj.medianValue}}</p>
                <p class="n-tester-pin-info-text" *ngIf="pinObj.averageValue">{{pinObj.averageValue}}</p>
                <p class="n-tester-pin-info-text" *ngIf="pinObj.yieldTarget">{{pinObj.yieldTarget}}</p>
                <p class="n-tester-pin-info-text" *ngIf="pinObj.alreadyApplied">{{pinObj.alreadyApplied}}</p>
                <p class="n-tester-pin-info-text" *ngIf="pinObj.proteinTarget">{{pinObj.proteinTarget}}</p>
                <p class="n-tester-pin-info-text" *ngIf="pinObj.nRecommendation">{{pinObj.nRecommendation}}</p>
            </ng-container>

        </div>
    </div>
</div>
